import { defineSseEvent } from '@terra/shared-sse-contracts';
import { TargetTypeSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';

export const FINDINGS_UPDATED_SSE_TYPE = 'findings.updated' as const;
export const FINDING_POC_UPDATED_SSE_TYPE = 'finding.poc.updated' as const;

export const FindingsUpdatedSsePayloadSchema = z.object({
  ids: z.array(z.string()),
});

export type FindingPocUpdatedEventPayload = z.output<
  typeof FindingPocUpdatedEventPayloadSchema
>;

export const FindingPocUpdatedEventPayloadSchema = z.object({
  findingId: z.string(),
  targetId: z.string(),
  targetType: TargetTypeSchema,
});

export const FINDINGS_UPDATED_SSE_EVENT = defineSseEvent({
  type: FINDINGS_UPDATED_SSE_TYPE,
  payload: FindingsUpdatedSsePayloadSchema,
  channelPrefix: 'findings-updated',
  channelKey: () => 'all',
});

export const FINDING_POC_UPDATED_SSE_EVENT = defineSseEvent({
  type: FINDING_POC_UPDATED_SSE_TYPE,
  payload: FindingPocUpdatedEventPayloadSchema,
  channelPrefix: 'finding-poc-updated',
  channelKey: ({ findingId }) => findingId,
  target: {
    type: (payload): string => String(payload.targetType),
    id: (payload) => payload.targetId,
  },
});

export type FindingsUpdatedSsePayload = z.infer<
  typeof FindingsUpdatedSsePayloadSchema
>;
